<template>
  <div id="login" class="login-wrap">
    <div class="login-box">
      <div class="left">
        <div class="left-inner">
          <img src="../../assets/logo.png" alt class="logo">
          <p>最专业的建筑设计平台
            <br>给予您设计上最强大的帮助
          </p>
        </div>
      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
    <div class="back-wrap" @click="backHome">
      <img src="../../assets/back.png" alt>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {}
  },
  methods: {
    backHome() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style lang="less">
.login-wrap {
  background-color: #1d2366;
  // background-image: url('../../assets/login-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  flex-direction: column;
  .login-box {
    height: 566px;
    background: #ffffff;
    display: flex;
    box-shadow: 0px 17px 35px 0px rgba(10, 13, 78, 1);
    border-radius: 8px;
    overflow: hidden;
    .left {
      width: 451px;
      background-color: #3c5ead;
      text-align: center;
      color: #ffffff;
      background-image: url('../../assets/login-box-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px 0 0 5px;
      .logo {
        width: 116px;
      }
      p {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        margin-top: 40px;
      }
    }
    .right {
      width: 393px;
      // padding: 66px 64px 0 64px;
      padding-top: 66px;
      text-align: center;
      color: #2c5ac8;
      position: relative;
      h1 {
        font-size: 24px;
        font-weight: 600;
        line-height: 33px;
      }
      h2 {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
      .qr-corner {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        img {
          width: 65px;
        }
      }
      .form-wrap {
        width: 70%;
        margin: 0 auto;
        &.qr-sign-in-form {
          width: auto;
          margin: auto;
          margin-top: -15px;
          .login-btn {
            margin: 0;
          }
        }
      }
      .tip {
        color: #a4a8ab;
        text-align: right;
        margin-top: 3px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        a.sign-link {
          color: #2c5ac8;
          cursor: pointer;
        }
        &.pwd-tip {
          cursor: pointer;
        }
      }
      .login-btn {
        width: 100%;
        height: 38px;
        background: #2c5ac8;
        border-radius: 8px;
        color: #ffffff;
        border: none;
        font-size: 16px;
        margin-top: 30px;
        margin-bottom: 7px;
        width: 70%;
        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        img {
          width: 15px;
          margin-left: 8px;
        }
      }
    }
  }
  .input-wrap {
    border-bottom: 1px solid #a4a8ab;
    display: flex;
    align-items: center;
    margin-top: 20px;
    label {
      font-size: 16px;
      font-weight: 600;
      color: #b9bdc7;
      line-height: 22px;
      padding: 6px 0;
      text-align: left;
      width: 20%;
      margin-right: 5%;
    }
    input {
      width: 75%;
      border: none;
      font-size: 16px;
      color: rgba(44, 90, 200, 1);
      line-height: 22px;
      background-color: #ffffff;
      &:focus {
        border: none;
        outline: none;
      }
      &.qr-input {
        width: 45%;
      }
    }
    a.qrcode {
      cursor: pointer;
      width: 30%;
      text-align: right;
    }
    .qr-loading {
      color: #b9bdc7;
    }
  }
}
.back-wrap {
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
  opacity: 0.7;
  img {
    width: 50px;
  }
  &:hover {
    opacity: 1;
  }
}
@media screen and (max-width: 990px) {
  .login-wrap {
    .login-box {
      height: 495px;
      .left {
        display: none;
      }
      .right {
        width: 90vw;
        padding-top: 35px;
        .form-wrap {
          width: 85%;
          margin: 0 auto;
          &.qr-sign-in-form {
            width: auto;
            margin: auto;
          }
        }
      }
    }
  }
}
</style>


